<!-- display-desktop-12 preview — a display ad in the right rail of a desktop
     publisher page, on the same stand-in page as the other desktop placements:
     a serif wordmark, a nav row with the site tools opposite it, then the
     article. The article keeps its column on the left and the ad sits in a rail
     beside it, as it does on placements 6 to 11 — but this rail unit is a tall
     one, running most of the height of the window, and like placement 11 it
     shows no creative at all. Google fills it as text: the advertiser's mark,
     a headline set very large over three lines, the advertiser's name, a
     three-line description, and a pair of buttons — a dismiss control and the
     call to action — pinned to the foot of the unit. -->
<app-desktop-frame>
  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- The site account button, tight against the top of the window. -->
    <div class="da-account d-flex justify-content-end">
      <i class="bi bi-person-circle" aria-hidden="true"></i>
    </div>

    <!-- The publisher wordmark. A stand-in logo, so it is set as text. -->
    <div class="da-wordmark">website</div>

    <!-- Site nav on the left, site tools on the right. -->
    <div class="da-nav d-flex flex-row align-items-start">
      <span
        *ngFor="let item of navItems"
        class="da-nav-item placeholder"
        aria-hidden="true"
      ></span>

      <div class="da-tools d-flex flex-row align-items-center ms-auto">
        <i class="bi bi-search" aria-hidden="true"></i>
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
        <i class="bi bi-share" aria-hidden="true"></i>
        <i class="bi bi-envelope" aria-hidden="true"></i>
        <i class="bi bi-rss" aria-hidden="true"></i>
      </div>
    </div>

    <!-- The article column and the ad rail beside it. -->
    <div class="da-content d-flex flex-row">
      <!-- The article the ad sits beside, and the lead image the window cuts
           off. Same skeleton as the placements that run above the article, just
           in a narrower share of the page. -->
      <div class="da-article">
        <div class="da-bars d-flex flex-column">
          <span
            *ngFor="let bar of bodyBars; let last = last"
            class="da-bar placeholder"
            [class.da-bar-short]="last"
            aria-hidden="true"
          ></span>
        </div>

        <div class="da-block" aria-hidden="true"></div>
      </div>

      <!-- START: Real ad -->
      <div class="da-ad d-flex flex-column">
        <!-- GenSingleImagePreviewData carries no logo field, so the mark is the
             Valamar asset rather than an authored one, the same compromise the
             other placements make. -->
        <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
        <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>

        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>

        <!-- The mock names the advertiser above the description rather than
             showing a mark a second time. GenSingleImagePreviewData carries no
             advertiser field, so the name is a literal here, the same
             compromise the other placements make. -->
        <div class="da-advertiser">Valamar</div>

        <div class="da-desc">
          {{ data.descriptions[0] || "Your description appears here" }}
        </div>

        <!-- The buttons sit at the foot of the unit however short the copy above
             them is, so the pair is pushed down rather than following the
             description. -->
        <div class="da-actions d-flex flex-row">
          <!-- The unit's dismiss control. It is ad chrome rather than authored
               copy, so it is a literal — there is no field for it on the
               template. The mock is a Croatian preview and reads "ZATVORI"
               there; it stays English here like the other placements, since the
               network localises its own chrome at serve time. -->
          <span class="da-close d-flex align-items-center justify-content-center">
            <span class="da-label">Close</span>
          </span>

          <a
            [href]="data.url" target="_blank" rel="noopener noreferrer"
            class="da-cta d-flex align-items-center justify-content-center"
          >
            <span class="da-label">
              {{ data.ctaText || "Your call to action" }}
            </span>
          </a>
        </div>

        <!-- The AdChoices badge is chrome the network draws over the unit, so it
             is decorative here. The mock puts it below the buttons in the foot
             of the unit rather than in a corner of the copy. -->
        <span
          class="da-adchoices d-flex align-items-center justify-content-center"
        >
          <i class="bi bi-info-circle" aria-hidden="true"></i>
        </span>
      </div>
      <!-- END: Real ad -->
    </div>
  </div>
  <!-- END: Publisher page -->
</app-desktop-frame>
